import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
  Divider,
  Flex,
  Dropdown,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getEmployee } from '../../../network/employee';
import { submitMaterialRequest } from '../../../network/materialRequest';
import {
  addPayrollEntry,
  AddPayrollEntryMakeBank,
  CreateSalarySlipsPayroll,
  getCompanyDetailsPayroll,
  getEmployeesPayroll,
  getPayrollEntryDetails,
  getPayrollEntryHasBank,
  SubmitSalarySlipsPayroll,
  updatePayrollEntry,
} from '../../../network/payrollEntry';
import {
  getSearchApi,
  getSearchApiSearchText,
} from '../../../network/itemList';
import EmployeesList from './EmployeesList';
import { DownOutlined } from '@ant-design/icons';
import { FaMoneyBills } from 'react-icons/fa6';
import { RiSendPlaneFill } from 'react-icons/ri';
import HeadingApp from '../../../hooks/HeadingApp';
import { MdAssignmentAdd } from 'react-icons/md';
const AddPayrollEntry = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
  const [searchTextPayrollPayableAccount, setSearchTextPayrollPayableAccount] =
    useState('');
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const [dataSource, setDataSource] = useState([{}]);
  const [searchTextItems, setSearchTextItems] = useState('');
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const watchPostingDate = Form.useWatch('posting_date', form);
  const watchStatus = Form.useWatch('status', form);
  const { mutate: onAddAdditionalSalay } = useMutation({
    mutationKey: ['addAdditionalSalay'],
    mutationFn: (body) =>
      edit ? updatePayrollEntry(body, id) : addPayrollEntry(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      client.invalidateQueries({ queryKey: [queryKeys.getPayrollEntry] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/payroll-entry-hr');
    },

    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const CreateSalarySlips = useMutation({
    mutationFn: (id) => submitMaterialRequest('Payroll Entry', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getPayrollEntryDetails, selectName],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const SubmitSalarySlips = useMutation({
    mutationFn: (id) => SubmitSalarySlipsPayroll(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getPayrollEntryDetails, selectName],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => AddPayrollEntryMakeBank(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.payrollEntryHasBank, selectName],
      });
      // navigate('/payroll-entry-hr');
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data: additionalSalayDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getPayrollEntryDetails, selectName],
    queryFn: () => getPayrollEntryDetails(selectName),
    enabled: !!selectName,
  });

  const { data: companyInfo } = useQuery({
    queryKey: [queryKeys.getCompanyDetailsPayroll, companyName],
    queryFn: () => getCompanyDetailsPayroll(companyName),
  });
  useEffect(() => {
    if (companyInfo?.message && !edit) {
      form.setFieldsValue({
        payroll_payable_account:
          companyInfo?.message?.default_payroll_payable_account,
        cost_center: companyInfo?.message?.cost_center,
      });
    }
  }, [companyInfo, form]);
  const { data: payrollPayableAccount } = useQuery({
    queryKey: [
      queryKeys.getSearchpayrollPayableAccount,
      searchTextPayrollPayableAccount,
    ],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Account',
        searchTxt: searchTextPayrollPayableAccount,
      }),
    keepPreviousData: true,
  });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch, searchTextCostCenter],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Cost Center',
        searchTxt: searchTextCostCenter,
      }),
    keepPreviousData: true,
  });
  const { data: payrollEntryHasBank } = useQuery({
    queryKey: [queryKeys.payrollEntryHasBank, selectName],
    queryFn: () => getPayrollEntryHasBank(selectName),
    enabled: !!selectName,
  });
  const { data: employeesPayroll, isLoading: isLoadingPayroll } = useQuery({
    queryKey: [queryKeys.getEmployeesPayroll, selectName],
    queryFn: () => getEmployeesPayroll(selectName),
    enabled: !!selectName,
  });
  useEffect(() => {
    if (employeesPayroll?.message?.length > 0 && !edit) {
      setDataSource(
        employeesPayroll?.message?.map((item, index) => ({
          ...item,
          key: index + 1,
        }))
      );
    }
  }, [employeesPayroll]);
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddAdditionalSalay({
      ...values,
      company: companyName,
      currency: 'SAR',
      exchange_rate: 1.0,
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      start_date: dayjs(values?.start_date).format('YYYY-MM-DD'),
      end_date: dayjs(values?.end_date).format('YYYY-MM-DD'),
      validate_attendance: values?.validate_attendance ? 1 : 0,
      employees: dataSource?.[0]?.employee ? dataSource : [],
    });
  };
  useEffect(() => {
    if (selectName && additionalSalayDetails & !edit) {
      setDataStatus(additionalSalayDetails?.data?.docstatus);

      // setDataSource(additionalSalayDetails?.data?.employees);
      form.setFieldsValue({
        ...additionalSalayDetails?.data,
        posting_date: dayjs(additionalSalayDetails?.data?.posting_date),
        start_date: dayjs(additionalSalayDetails?.data?.start_date),
        end_date: dayjs(additionalSalayDetails?.data?.end_date),
      });
    } else if (id && edit) {
      setSelectName(id);
      setDataSource(additionalSalayDetails?.data?.employees);
      form.setFieldsValue({
        ...additionalSalayDetails?.data,
        posting_date: dayjs(additionalSalayDetails?.data?.posting_date),
        start_date: dayjs(additionalSalayDetails?.data?.start_date),
        end_date: dayjs(additionalSalayDetails?.data?.end_date),
      });
    }
  }, [selectName, additionalSalayDetails, form, id, edit]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  const itemsMenu = [
    {
      key: '1',
      label: (
        <Button
          size="small"
          type="text"
          style={{ width: '100%' }}
          icon={<FaMoneyBills />}
          disabled={
            additionalSalayDetails?.data?.salary_slips_created === 0
              ? false
              : true
          }
        >
          {t.CreateSalarySlips}
        </Button>
      ),
      onClick: () => {
        CreateSalarySlips.mutate(selectName);
      },
    },
    {
      key: '2',
      label: (
        <Button
          size="small"
          type="text"
          style={{ width: '100%' }}
          icon={<RiSendPlaneFill />}
          disabled={
            additionalSalayDetails?.data?.salary_slips_created === 0
              ? true
              : additionalSalayDetails?.data?.salary_slips_submitted === 0
              ? false
              : true
          }
        >
          {t.SubmitSalarySlips}
        </Button>
      ),
      onClick: () => {
        SubmitSalarySlips.mutate(selectName);
      },
    },
    {
      key: '3',
      label: (
        <Button
          size="small"
          type="text"
          style={{ width: '100%' }}
          icon={<RiSendPlaneFill />}
          disabled={
            additionalSalayDetails?.data?.salary_slips_submitted === 0
              ? true
              : payrollEntryHasBank?.message === 0
              ? false
              : true
          }
          // disabled={payrollEntryHasBank?.message === 0 ? false : true}
        >
          {t.SubmitBankEntry}
        </Button>
      ),
      onClick: () => {
        handleSubmit.mutate(selectName);
      },
    },
  ];
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.EditPayrollEntry : t.AddPayrollEntry}
        path="/payroll-entry-hr"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.PayrollEntry}
        subTitle={edit ? t.EditPayrollEntry : t.AddPayrollEntry}
        icon={<MdAssignmentAdd />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Flex justify="end" align="center">
          {selectName && (
            <Dropdown
              menu={{ items: itemsMenu }}
              trigger={['click']}
              arrow
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text" className="btn-light">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          form={form}
          name="add-attandence"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                      disabledDate={(current) => {
                        return current && current < dayjs().startOf('day');
                      }}
                      onChange={(date, option) => {
                        form.setFieldsValue({
                          start_date: dayjs(date).startOf('month'),
                          end_date: dayjs(date).endOf('month'),
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="start_date"
                    label={t.startDate}
                    initialValue={dayjs(watchPostingDate).startOf('month')}
                  >
                    <DatePicker
                      placeholder={t.startDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="end_date"
                    label={t.EndDate}
                    initialValue={dayjs(watchPostingDate).endOf('month')}
                  >
                    <DatePicker
                      placeholder={t.EndDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="payroll_frequency"
                    label={t.payrollFrequency}
                    rules={[{ required: true }]}
                    initialValue="Monthly"
                  >
                    <Select
                      placeholder={t.payrollFrequency}
                      options={[
                        { value: 'Monthly', label: 'Monthly' },
                        { value: 'Weekly', label: 'Weekly' },
                        { value: 'Daily', label: 'Daily' },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="payroll_payable_account"
                    label={t.payrollPayableAccount}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.payrollPayableAccount}
                      showSearch
                      optionFilterProp="children"
                      filterOption={false}
                      onSearch={(value) => {
                        setSearchTextPayrollPayableAccount(value);
                      }}
                      onChange={(value) => {
                        setSearchTextPayrollPayableAccount('');
                      }}
                      options={payrollPayableAccount?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="cost_center"
                    label={t.costCenter}
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      allowClear
                      filterOption={false}
                      onSearch={(value) => {
                        setSearchTextCostCenter(value);
                      }}
                      placeholder={t.costCenter}
                      options={costCenters?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="payment_account"
                    label={t.paymentAccount}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.paymentAccount}
                      showSearch
                      optionFilterProp="children"
                      filterOption={false}
                      onSearch={(value) => {
                        setSearchTextPayrollPayableAccount(value);
                      }}
                      onChange={(value) => {
                        setSearchTextPayrollPayableAccount('');
                      }}
                      options={payrollPayableAccount?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                  }}
                >
                  <Form.Item
                    name="validate_attendance"
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox>{t.validateAttendance}</Checkbox>
                  </Form.Item>
                </Col>

                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item name="status" label={t.status} hidden={!edit}>
                <Input placeholder={t.status} disabled />
              </Form.Item>
            </Col> */}
                {selectName && (
                  <Col span={24}>
                    <Divider>{t.Employees}</Divider>
                    <EmployeesList
                      t={t}
                      dataSource={dataSource}
                      setDataSource={setDataSource}
                      employee={employeesPayroll?.message || dataSource}
                      isLoadingPayroll={isLoadingPayroll}
                    />
                  </Col>
                )}
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    if (submitButton) {
                      // setLoadingAdd(true);
                      // handleSubmit.mutate(selectName);
                      if (
                        watchStatus === 'Submitted' &&
                        payrollEntryHasBank?.message === 0
                      ) {
                        setLoadingAdd(true);
                        handleSubmit.mutate(selectName);
                      } else {
                        form.submit();
                      }
                    } else {
                      form.submit();
                    }
                  }}
                  loading={loadingAdd}
                >
                  {submitButton
                    ? watchStatus === 'Submitted'
                      ? payrollEntryHasBank?.message === 0
                        ? t.submit
                        : t.Save
                      : t.Save
                    : edit
                    ? t.edit
                    : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddPayrollEntry;
